import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { setVadBatteryStatusOptions } from '../store/options.actions'

export function* getVadBatteryStatusOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getVadBatteryStatusOptions])
    const { entity } = response
    yield put(setVadBatteryStatusOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getVadBatteryStatusOptions() error: ${e}`))
  }
}
export function* getVadBatteryStatusOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getVadBatteryStatusOptions)
}
